const googleApiKey = 'AIzaSyBK4U6VoWrF1UcS3j_9eTDvPuJSeT9Pjgs'


export default googleApiKey
